import { config } from "@/config";
import { chatApiAxios } from "@/plugins";
import { checkAccessTokenAsync } from "@/services";
import { HttpRequestMethodEnum } from "@/types/api";
import { IUpdateAttachmentProgressArgs } from "@/types/chat";
import { getCommonJsonHeaders } from "@/utils/api";

export const updateAttachmentProgressBeAsync = async (
  data: IUpdateAttachmentProgressArgs,
) => {
  const accessToken = await checkAccessTokenAsync();

  const res = await chatApiAxios(
    config.api.chatApi.endpoints.message.updateAttachmentUploadProgress,
    {
      method: HttpRequestMethodEnum.POST,
      headers: getCommonJsonHeaders(accessToken),
      data,
    },
  );

  return res.data;
};
